import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { filter, map } from 'rxjs';

import { AuthUserStateService } from '../services';
import { NavigationWebService } from '../services/navigation.service';

export const IsClinicGuard: CanActivateFn = () => {
  const authStateS = inject(AuthUserStateService);
  const navService = inject(NavigationWebService);
  const router = inject(Router);

  return authStateS.authProfile$.pipe(
    filter(profile => !!profile),
    map(profile =>
      profile.is_clinic_account
        ? true
        : router.createUrlTree(navService.getBaseSegments()),
    ),
  );
};
